import { createActionTypes } from "@helpers/redux-helpers";
import { setDefaultCardAsync } from "@redux/paymentCards/saga";

export const getPaymentSubscriptionsActionTypes =
  createActionTypes("payments/get");

export const getPaymentSubscriptionsPortionActionTypes = createActionTypes(
  "payments/getPortion",
);

export const getListSubscriptionsActionTypes = createActionTypes(
  "payments/subscriptions/getList",
);

export const getListContentRequestsActionTypes = createActionTypes(
  "payments/content-requests/getList",
);

export const getListDonationsActionTypes = createActionTypes(
  "payments/donations/getList",
);

export const resetPaymentsListActionTypes = createActionTypes("payments/reset");

export const cancelSubscriptionActionTypes = createActionTypes(
  "subscriptions/cancel",
);

// todo: implement after backend update
export const submitTransferActionTypes = createActionTypes(
  "payments/submitTransfer",
);

export const cryptoTxActionTypes = createActionTypes("payments/crypto");

export const getPromotionsActionTypes = createActionTypes(
  "payments/promotions",
);

export const getAgencyActionTypes = createActionTypes("payments/agency");

export const addPayoutMethodActionTypes = createActionTypes(
  "payments/addPayoutMethod",
);

export const sendDonationActionTypes = createActionTypes(
  "payments/send/donation",
);

export const setDefaultCardActionTypes = createActionTypes(
  "payments/set/card/default",
);

export const getAgencyUsersActionTypes = createActionTypes(
  "payments/get/agency/users",
);
